import Vue from 'vue';

import DefaultLayout from '@/layouts/DefaultLayout.vue';
import AuthenticationLayout from '@/layouts/AuthenticationLayout.vue';
import TabBarLayout from '@/layouts/TabBarLayout.vue';

Vue.component('default-layout', DefaultLayout);
Vue.component('authentication-layout', AuthenticationLayout);
Vue.component('tab-bar-layout', TabBarLayout);
